export default "__VITE_ASSET__CCg$XKHz__"